import React, { memo, useMemo } from 'react';
import { graphql, useFragment } from 'react-relay';
import { DropdownTrigger } from '@atlassian/entry-point-dropdown';
import { useIntl } from '@atlassian/jira-intl';
import type { FiltersMenu_project$key } from '@atlassian/jira-relay/src/__generated__/FiltersMenu_project.graphql';
import messages from './FiltersMenu.messages.tsx';
import { filtersMenuEntryPoint } from './entrypoint.tsx';

type FiltersMenuProps = {
	onChangeFilter?: (filterId?: string) => void;
	projectFragment: FiltersMenu_project$key;
};

export const FiltersMenu = memo(({ onChangeFilter, projectFragment }: FiltersMenuProps) => {
	const projectData = useFragment(
		graphql`
			fragment FiltersMenu_project on JiraProject {
				id @required(action: THROW)
			}
		`,
		projectFragment,
	);

	const { formatMessage } = useIntl();

	const entryPointParams = useMemo(
		() => ({
			searchParameters: {
				contextId: projectData.id,
			},
			// TODO: Confirm actual limit
			first: 50,
		}),
		[projectData?.id],
	);

	const entryPointProps = useMemo(
		() => ({
			onChangeFilter,
		}),
		[onChangeFilter],
	);

	return (
		<DropdownTrigger
			entryPoint={filtersMenuEntryPoint}
			entryPointParams={entryPointParams}
			entryPointProps={entryPointProps}
			trigger={formatMessage(messages.dropdownTitle)}
		/>
	);
});
